/**
 * Chama Chat — app-level Concord configuration.
 *
 * The moderator (community owner) is the person who reviews join requests and
 * founds the community. Everything Concord-specific lives in `src/lib/concord/`.
 */

/** Pubkey of the moderator who reviews applications (the community owner). */
export const MODERATOR_PUBKEY =
  "932614571afcbad4d17a191ee281e39eebbb41b93fac8fd87829622aeb112f4d";

/**
 * Relays the community publishes its Concord planes on. These must serve
 * kind 1059 by author (Concord reverses NIP-59's wrap addressing), which
 * Soapbox's relays and the large public relays below all do.
 */
export const COMMUNITY_RELAYS = [
  "wss://relay.ditto.pub",
  "wss://relay.dreamith.to",
  "wss://nos.lol",
  "wss://relay.damus.io",
];

/** App-specific rumor kinds (ride inside giftwraps; see NIP.md). */
export const JOIN_REQUEST_KIND = 8031;
export const JOIN_RESPONSE_KIND = 9583;

/** Concord wire kinds (CORD-02, Appendix B). */
export const KIND_WRAP = 1059;
export const KIND_SEAL_ENCRYPTED = 20013;
export const KIND_SEAL_PLAINTEXT = 20014;
export const KIND_CHAT_MESSAGE = 9;
export const KIND_REACTION = 7;
export const KIND_DELETE = 5;
export const KIND_EDIT = 3302;
export const KIND_EDITION = 3308;
export const KIND_JOIN_LEAVE = 3306;
export const KIND_KICK = 3309;
export const KIND_SNAPSHOT = 3312;
export const KIND_DIRECT_INVITE = 3313;
export const KIND_COMMUNITY_LIST = 33302;

export const APP_NAME = "Chama Chat";
export const COMMUNITY_DEFAULT_NAME = "Chama";
export const COMMUNITY_DEFAULT_DESCRIPTION =
  "A private chama for Kenya-based women building open-source Bitcoin and Nostr software.";
